const routes = [
  {
    path: '/m/yuren/inputstudentinfo',
    name: 'mInputStudentInfo',
    component: () => import('@/views/yurenManagement/mobile/InputStudentInfo'),
  },
  {
    path: '/m/learningHub',
    name: 'mLearningHub',
    component: () => import('@/views/learningHub/mobile/index.mobile.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: '/m/learningHub/search',
    name: 'mLearningHubSearch',
    component: () => import('@/views/learningHub/mobile/Search.vue'),
    meta: {
      title: '学习园地',
    },
  },
  {
    path: '/m/learningHub/more',
    name: 'mLearningHubMore',
    component: () => import('@/views/learningHub/mobile/index.mobile.more.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: '/m/schoolOpensBenefits',
    name: 'mSchoolOpensBenefits',
    component: () => import('@/views/schoolOpensBenefits/index.mobile.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/m/ssoLogin',
    name: 'mSsoLogin',
    component: () => import('@/views/ssoLogin/mobile/index.mobile.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/m/fission',
    name: 'mFission',
    component: () => import('@/views/fissionConfigurable/Fission.mobile.vue'),
    meta: {
      title: 'WPS 365教育版 | 锦鲤活动',
    },
  },
  // 登录后引导导入文档和关联权益
  {
    path: '/m/relatedAccount',
    name: 'mRelatedAccount',
    component: () => import('@/views/relatedAccount/RelatedAccount.m.vue'),
    meta: {
      title: '',
    },
  },
  // 题库C转B
  {
    path: '/m/question-privilege',
    name: 'mQuestionPrivilege',
    component: () => import('@/views/questionPrivilege/QuestionPrivilege.m.vue'),
    meta: {
      title: 'WPS 计算机备考福利大放送！',
    },
  },
  // 春芽活动
  {
    path: '/m/greenShoots',
    name: 'mGreenShoots',
    component: () => import('@/views/greenShoots/GreenShoots.m.vue'),
    meta: {
      title: '开学新装备，WPS权益免费用',
    },
  },
  // 春芽活动
  {
    path: '/m/greenShootsV2',
    name: 'mGreenShootsV2',
    component: () => import('@/views/greenShootsV2/GreenShoots.m.vue'),
    meta: {
      title: '春芽再起航，成长进阶2.0',
    },
  },
  // 教育 Web 中间跳转页
  {
    path: '/m/eduWebRedirect',
    name: 'mEduWebRedirect',
    component: () => import('@/views/eduWebRedirect/EduWebRedirect.m.vue'),
    meta: {
      title: '',
    },
  },
]

export default routes